import { render, staticRenderFns } from "./SimpleAddressDlg.vue?vue&type=template&id=2948329a"
import script from "./SimpleAddressDlg.vue?vue&type=script&lang=js"
export * from "./SimpleAddressDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports